/** UI review (deferred): per-building / per-position overrides of "assigned shifts need employee confirmation". */
export interface ConfirmationOverride {
  location_id?: string | null;
  position_id?: string | null;
  needs_confirmation: boolean;
}

export const MAX_CONFIRMATION_REMINDERS = 3;

/**
 * Whether a newly assigned shift should ask the employee to confirm. Most specific rule wins:
 * building + position, then position (any building), then building (any position), then the workspace default.
 */
export function confirmationDefault(
  settings: { shift_confirmation_default?: boolean | null; confirmation_overrides?: ConfirmationOverride[] | null } | null | undefined,
  locationId: string | null | undefined, positionId: string | null | undefined,
): boolean {
  const rules = settings?.confirmation_overrides ?? [];
  const find = (loc: string | null, pos: string | null) => rules.find(r => (r.location_id ?? null) === loc && (r.position_id ?? null) === pos);
  const hit = (locationId && positionId ? find(locationId, positionId) : undefined)
    ?? (positionId ? find(null, positionId) : undefined)
    ?? (locationId ? find(locationId, null) : undefined);
  return hit ? hit.needs_confirmation : Boolean(settings?.shift_confirmation_default);
}

/** Reminder points, largest first, without duplicates: "48h and 12h before". */
export function describeReminderHours(hours: number[] | null | undefined): string {
  const list = [...new Set(hours ?? [])].sort((a, b) => b - a);
  if (!list.length) return 'No automatic reminders';
  const one = (h: number) => (h % 24 === 0 ? `${h / 24} day${h === 24 ? '' : 's'}` : `${h} hour${h === 1 ? '' : 's'}`);
  return `Reminds ${list.map(one).join(', ').replace(/, ([^,]*)$/, ' and $1')} before the shift`;
}
